import React from "react"

interface PageHeaderProps {
  title: string
  description?: React.ReactNode
  rightElement?: React.ReactNode
}

export function PageHeader({ title, description, rightElement }: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between pt-[16px]">
      <div className="space-y-[4px]">
        <h1 className="text-[24px] text-[#08090A] font-normal">{title}</h1>
        {description && (
          <p className="text-[13px] text-[#8A8F98]">
            {description}
          </p>
        )}
      </div>
      {rightElement && (
        <div>
          {rightElement}
        </div>
      )}
    </div>
  )
}

